<app-call-display
  (callInitiated)="initiateCall($event)"
  (callEnded)="endCall($event)"
  (callUpdated)="updateCall($event)"
  (callCanceled)="destroyCall($event)"
  (callMuted)="muteCall($event)"
  (toggleSilentMonitorMute)="toggleSilentMonitorMuteState($event)"
  (placeCallOnHold)="placeCallOnHold($event)"
  (startSecondCall)="startSecondCall($event)"
  (transferCall)="transferCall($event)"
  (swapCalls)="swapCalls()"
  (mergeCalls)="mergeCalls()"
  (completeCallWrapUp)="completeCallWrapUp()"
  (callAlertDismissed)="dismissCallAlert($event)"
  (openWrapUp)="wrapUpDialog($event)"
  (queueCall)="queueCall($event)"
  [unendedCall]="unendedCall"
  [alerts]="alerts$ | async"
  [activeCall]="call$ | async"
  [secondaryCall]="secondaryCall$ | async"
  [dispositionCall]="dispositionCall$ | async"
  [callTimers]="callTimers$ | async"
  [callIsMuted]="callMuteStatus$ | async"
  [callStateIsProcessing]="callStateIsProcessing$ | async"
  [twilioDeviceIsLoading]="twilioDeviceIsLoading$ | async"
  [silentMonitorInProgress]="(silentMonitorInProgress$ | async)"
  [canUnmuteSilentMonitorCall]="(canUnmuteSilentMonitorCall$ | async)"
  [queue]="queue$ | async"
  [(timerOpen)]="timerOpen">
</app-call-display>
